module.exports = "pegasus_template/assets/lp/charity/bg1.png";